import React from 'react';
import _ from 'lodash';
import { inject, observer } from 'mobx-react';
import PropTypes from 'prop-types';
import SelectComponent from '../../shared_components/SelectComponent';
import InformationBoxComponent from '../../shared_components/InformationBoxComponent';

@observer
class ComparisonProviderFormComponent extends React.Component {
  constructor(props) {
    super(props);

    this.showTextBox = this.showTextBox.bind(this);
  }

  showTextBox(data, event) {
    event.stopPropagation();
    this.props.ModalData.openModal(data);
  }

  render() {
    const {
      classNames,
      labels,
      providers,
      labelName,
      providerName,
      providerId,
      labelId,
      setProvider,
      setLabel,
    } = this.props;

    const { informationBoxData } = this.props.InformationBoxData;

    let selectedLogo;

    if (providers.length > 0) {
      const selectedProvider = providers.find(provider => provider.id === providerId);

      /* Because labels are loaded async, make sure there is a logo property */
      selectedLogo = _.has(selectedProvider, 'logo') ? selectedProvider.logo : '';
    }

    return (
      <div className={classNames}>
        <div className="row columns comparison-form__logo-container">
          <div className="columns medium-15">
            <img
              className="comparison-form__provider__label-logo"
              src={selectedLogo} alt=""
            />
          </div>
        </div>
        <div className="row columns">
          <SelectComponent
            onChangeHandler={(e) => { setProvider(e.target.value, providerName); }}
            labels={providers}
            selected={providerId}
            name={providerName}
            label="Verstrekker"
            classNames="medium-42 columns search"
          >
            <InformationBoxComponent
              classNames="info-box-select"
              onClickHandler={
                (event) => {
                  this.showTextBox(informationBoxData.label, event);
                }
              }
            />
          </SelectComponent>
          <SelectComponent
            onChangeHandler={(e) => { setLabel(e.target.value, labelName); }}
            labels={labels}
            selected={labelId}
            name={labelName}
            label="Product"
            classNames="medium-42 columns search"
          />
        </div>
      </div>
    );
  }
}

ComparisonProviderFormComponent.propTypes = {
  ModalData: PropTypes.shape({
    openModal: PropTypes.func,
  }),
  InformationBoxData: PropTypes.shape({
    informationBoxData: PropTypes.shape({
      header: PropTypes.string,
      text: PropTypes.string,
    }),
  }),
  classNames: PropTypes.string,
  providers: PropTypes.oneOfType([
    PropTypes.shape({}),
    PropTypes.arrayOf(PropTypes.shape({})),
  ]),
  labels: PropTypes.arrayOf(PropTypes.shape({})),
  labelName: PropTypes.string,
  providerName: PropTypes.string,
  providerId: PropTypes.number,
  labelId: PropTypes.number,
  setProvider: PropTypes.func,
  setLabel: PropTypes.func,
};

ComparisonProviderFormComponent.defaultProps = {
  ModalData: {
    openModal: () => {},
  },
  InformationBoxData: {
    informationBoxData: {
      header: '',
      text: '',
    },
  },
  classNames: '',
  providers: [],
  labels: [],
  labelName: '',
  providerName: '',
  providerId: 0,
  labelId: 0,
  setProvider: () => {},
  setLabel: () => {},
};

export default inject('InformationBoxData', 'InformationBoxData', 'ModalData')(ComparisonProviderFormComponent);
